(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const positionKey = 'whatdhook-custom-cursor-position';

  const initCustomCursor = () => {
    if (!finePointer.matches) return;

    const cursor = document.querySelector('[data-custom-cursor]');
    if (!cursor) return;
    const cursorImage = cursor.querySelector('img');
    if (!cursorImage) return;

    let x = -100;
    let y = -100;
    let frame;

    const restorePosition = () => {
      try {
        const savedPosition = JSON.parse(sessionStorage.getItem(positionKey));

        if (
          Number.isFinite(savedPosition?.x) &&
          Number.isFinite(savedPosition?.y) &&
          savedPosition.x >= 0 &&
          savedPosition.x <= window.innerWidth &&
          savedPosition.y >= 0 &&
          savedPosition.y <= window.innerHeight
        ) {
          x = savedPosition.x;
          y = savedPosition.y;
          cursor.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
          cursor.classList.add('is-visible');
        }
      } catch (error) {
        // sessionStorage can be unavailable in privacy-restricted browsers.
      }
    };

    const savePosition = () => {
      try {
        sessionStorage.setItem(positionKey, JSON.stringify({ x, y }));
      } catch (error) {
        // The cursor still works without cross-page position persistence.
      }
    };

    const enableCursor = () => {
      document.documentElement.classList.add('custom-cursor-enabled');
    };

    const render = () => {
      cursor.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
      savePosition();
      frame = undefined;
    };

    const moveCursor = (event) => {
      x = event.clientX;
      y = event.clientY;
      cursor.classList.add('is-visible');

      if (!frame) frame = requestAnimationFrame(render);
    };

    restorePosition();

    if (cursorImage.complete && cursorImage.naturalWidth) {
      enableCursor();
    } else {
      cursorImage.addEventListener('load', enableCursor, { once: true });
    }

    document.addEventListener('mousemove', moveCursor, { passive: true });
    document.addEventListener('mousedown', (event) => {
      x = event.clientX;
      y = event.clientY;
      savePosition();
      cursor.classList.add('is-pressed');
    });
    document.addEventListener('mouseup', () => cursor.classList.remove('is-pressed'));
    document.documentElement.addEventListener('mouseleave', () => cursor.classList.remove('is-visible'));
    window.addEventListener('blur', () => cursor.classList.remove('is-visible'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomCursor, { once: true });
  } else {
    initCustomCursor();
  }
})();
